import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

export function getStudentEvent(user: AppUser, eventId) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.get(`${window.apiBase}/i/events/${eventId}`, config).then(response => {
    return response.data;
  });
}

export function getStudentEvents(user: AppUser, filter) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter: filter
    }
  };

  return axios.get(`${window.apiBase}/i/events`, config).then(response => {
    return response.data;
  });
}

export function getStudentEventsDates(user: AppUser, filter) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter: filter
    }
  };

  return axios.get(`${window.apiBase}/i/events/dates/distinct`, config).then(response => {
    return response.data;
  });
}

export interface StudentCalendarData {
  schools: Array<{ id: string; name: string; pic?: string }>;
  fixtureEventDates: { dates: string[] };
  fixtureEvents: any[];
  clubEventDates: { dates: string[] };
  clubEvents: any[];
  tournamentEventDates: { dates: string[] };
  tournamentEvents: any[];
}

export function getStudentCalendarData(
  user: AppUser,
  monthAndYearDate: Date,
  selectedDate: Date,
  schoolIdList: string[],
  filterType: string
): Promise<StudentCalendarData> {
  const { roleSessionKey: key } = user;
  const monthStart = new Date(monthAndYearDate.getFullYear(), monthAndYearDate.getMonth(), 1);
  const monthEnd = new Date(monthAndYearDate.getFullYear(), monthAndYearDate.getMonth() + 1, 1);
  const dayStart = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
  const dayEnd = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate() + 1);

  return axios
    .get<StudentCalendarData>(`${window.apiBase}/i/events/calendar`, {
      headers: { usid: key },
      params: {
        monthStart: monthStart.toISOString(),
        monthEnd: monthEnd.toISOString(),
        dayStart: dayStart.toISOString(),
        dayEnd: dayEnd.toISOString(),
        schoolIds: schoolIdList.join(','),
        filterType
      }
    })
    .then(response => response.data);
}

export function sentStudentAvailabilityReport(user: AppUser, eventId, data) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.post(`${window.apiBase}/i/events/${eventId}/messages/report`, data, config).then(response => {
    return response.data;
  });
}

export function getStudentEventKits(user: AppUser, eventId: string) {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.get(`${window.apiBase}/i/events/${eventId}/kits`, config).then(response => response.data);
}

export function getStudentEventPhotos(user: AppUser, eventId: string) {
  const { roleSessionKey: key } = user;
  const config = {
    headers: { usid: key },
    params: { filter: { limit: 500, skip: 0 } }
  };
  return axios.get(`${window.apiBase}/i/events/${eventId}/photos`, config).then(response => response.data);
}

export function addStudentEventPhoto(user: AppUser, eventId: string, data: { picUrl: string; accessPreset?: string }) {
  const { roleSessionKey: key } = user;
  const config = { headers: { usid: key } };
  return axios.post(`${window.apiBase}/i/events/${eventId}/photos`, data, config).then(response => response.data);
}

export function deleteStudentEventPhoto(user: AppUser, eventId: string, photoId: string) {
  const { roleSessionKey: key } = user;
  const config = { headers: { usid: key } };
  return axios
    .delete(`${window.apiBase}/i/events/${eventId}/photos/${photoId}`, config)
    .then(response => response.data);
}
